import {InjectionToken} from "@angular/core";
import {DeleteEntityModel} from "../_models/DeleteEntityModel";
import {ModelKey} from "../../../models/ModelKey";
import {IModalController} from "../../../controllers/IModalController";

export const IT_DELETE_ENTITY_CONTROLLER = new InjectionToken<IDeleteEntityController>('IT_DELETE_ENTITY_CONTROLLER');

export const MK_DELETE_ENTITY = new ModelKey<DeleteEntityModel>('MK_DELETE_ENTITY');

export interface IDeleteEntityController extends IModalController {

  handleToggleTreeNodes(eventData: any): any;
}
